import { render, staticRenderFns } from "./JgBespokeEveri.vue?vue&type=template&id=0dc829e7&scoped=true&"
import script from "./JgBespokeEveri.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeEveri.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeEveri.vue?vue&type=style&index=0&id=0dc829e7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc829e7",
  null
  
)

export default component.exports